module.exports = __webpack_public_path__ + "static/media/lock.01f84367.svg";